<mat-sidenav-container class="sidenav-container">
  <mat-sidenav
    #drawer
    class="sidenav"
    fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    position="end">
    <mat-toolbar>
      <img
        src="assets/images/pcl_construction_craftlink.svg"
        class="mat-toolbar-mobile-logo"
        alt="PCL Construction CraftLink logo" />
    </mat-toolbar>
    <mat-nav-list>
      <a mat-list-item [routerLink]="['/', 'jobs']" (click)="drawer.close()">Job Postings</a>
      @if (loginDisplay()) {
        <a mat-list-item [routerLink]="['/', 'applications']" (click)="drawer.close()">Your Applications</a>
        <a mat-list-item [routerLink]="['/', 'profile']" (click)="drawer.close()">Your Profile</a>
        <a mat-list-item [routerLink]="['/', 'wallet']" (click)="drawer.close()">Your Wallet</a>
        @if (evaluatorDisplay()) {
          <a mat-list-item [routerLink]="['/', 'evaluations']" (click)="drawer.close()">Pending Evaluations</a>
        }
        @if (portalDisplay()) {
          <a mat-list-item [routerLink]="['/', 'portal']" (click)="drawer.close()">Your Portal</a>
        }
        <a mat-list-item [routerLink]="['/', 'settings']" (click)="drawer.close()">Settings</a>
        <a mat-list-item (click)="logout()">Sign Out</a>
      } @else {
        <a mat-list-item (click)="loginRedirect()">Sign In</a>
      }
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content class="page-container">
    <mat-toolbar [ngClass]="(isHandset$ | async) ? '' : 'mat-toolbar-standard'">
      @if (isHandset$ | async) {
        <img
          src="assets/images/pcl_construction_craftlink.svg"
          class="mat-toolbar-mobile-logo"
          alt="PCL Construction CraftLink logo" />
        <span class="spacer"></span>
        <app-locale-selector></app-locale-selector>
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
      } @else {
        <div class="mat-toolbar-container">
          <img
            src="assets/images/pcl_construction_craftlink.svg"
            class="mat-toolbar-standard-logo"
            alt="PCL Construction CraftLink logo" />
          <nav class="nav">
            <ul class="flex-container wrap">
              <li><a class="nav-item" [routerLink]="['/', 'jobs']">Job Postings</a></li>
              @if (loginDisplay()) {
                <li>
                  <a class="nav-item" [routerLink]="['/', 'applications']"><span>Your Applications</span></a>
                </li>
              }
            </ul>
          </nav>
          <span class="spacer"></span>
          @if (!loginDisplay()) {
            <a class="nav-item alt" (click)="loginRedirect()">
              <span class="flex-container">
                <mat-icon>login</mat-icon>
                <span>Sign In</span>
              </span>
            </a>
          }
          @if (loginDisplay()) {
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Profile menu">
              <mat-icon>person</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item routerLink="/profile">
                <mat-icon>person</mat-icon>
                <span>Your Profile</span>
              </button>
              <button mat-menu-item routerLink="/wallet">
                <mat-icon>wallet</mat-icon>
                <span>Your Wallet</span>
              </button>
              @if (evaluatorDisplay()) {
                <button mat-menu-item routerLink="/evaluations">
                  <mat-icon>assignment</mat-icon>
                  <span>Pending Evaluations</span>
                </button>
              }
              @if (portalDisplay()) {
                <button mat-menu-item routerLink="/portal">
                  <mat-icon>account_circle</mat-icon>
                  <span>Your Portal</span>
                </button>
              }
              <mat-divider></mat-divider>
              <button mat-menu-item routerLink="/settings">
                <mat-icon>settings</mat-icon>
                <span>Settings</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>Sign Out</span>
              </button>
            </mat-menu>
          }
          <app-locale-selector></app-locale-selector>
        </div>
      }
    </mat-toolbar>
    <!-- Add Content Here -->
    @if ((isHandset$ | async) === false) {
      <div class="background-image"></div>
    }
    <div class="page-content">
      <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
      @if (!isIframe) {
        <router-outlet></router-outlet>
      }
    </div>
    <app-footer></app-footer>
    <app-loading-indicator></app-loading-indicator>
  </mat-sidenav-content>
</mat-sidenav-container>
